export default "__VITE_ASSET__a7086dae__"